import ZingTouch from 'zingtouch';
import _throttle from 'underscore/modules/throttle';
import MouseDrag from './mousedrag';

export default class Controls {
    constructor(el, parent) {
        this.el = el;
        this.parent = parent;
        this.config = parent.config;
        this.region = new ZingTouch.Region(el);
        this.zingPan = new ZingTouch.Pan();
        this.mouseDrag = new MouseDrag(el.parentElement, () => this.onDragEnd());
        this.controlType = this.el.dataset.controlType;
        this.controlReverse = this.el.dataset.controlReverse;
        this.arrowsEnable = this.el.dataset.arrowsEnable;
        this.arrowsReverse = this.el.dataset.arrowsReverse;
        this.isPan = !this.controlType || this.controlType === 'pan';
        this.isSwipe = !this.controlType || this.controlType === 'swipe';
        this.next = document.querySelector('.arrow-next');
        this.prev = document.querySelector('.arrow-prev');
        this.frames = [];
        this.bind();
    }

    bind() {
        this.next.addEventListener('click', () => {
            this.rotate(this.currentIndex + (this.arrowsReverse ? -1 : 1));
        });
        this.prev.addEventListener('click', () => {
            this.rotate(this.currentIndex - (this.arrowsReverse ? -1 : 1));
        });

        this.region.bind(this.el, this.zingPan, () => {});
        this.zingPan.start = (inputs) => this.start(inputs);
        this.zingPan.move = _throttle((inputs) => this.move(inputs), 100);
        this.zingPan.end = (inputs) => this.end(inputs);
    }

    start(inputs) {
        if (!this.paused) {
            if (this.isPan) {
                this.panStart(inputs);
            } else if (this.isSwipe) {
                this.swipeStart(inputs);
            }
        }
    }

    move(inputs) {
        if (!this.paused) {
            if (this.isPan) {
                this.panMove(inputs);
            } else if (this.isSwipe) {
                this.swipeMove(inputs);
            }
        }
    }

    end(inputs) {
        if (!this.paused) {
            if (this.isPan) {
                this.panEnd(inputs);
            } else if (this.isSwipe) {
                this.swipeEnd(inputs);
            }
        }
    }

    panStart(inputs) {
        this.startIndex = this.currentIndex;
        this.prevDiff = 0;
        this.el.classList.add('grabbing');
    }

    panMove(inputs) {
        const input = inputs[0];
        const distance = input.current.x - input.initial.x;
        const diff = Math.sign(distance) * Math.round(Math.abs(distance) / 50);
        if (diff !== this.prevDiff) {
            this.prevDiff = diff;
            this.rotate(this.startIndex + (this.controlReverse ? -diff : diff));
        }
    }

    panEnd(inputs) {
        this.el.classList.remove('grabbing');
    }

    swipeStart() {
        this.el.classList.add('grabbing');
    }

    swipeMove(inputs) {

    }

    swipeEnd(inputs) {
        const input = inputs[0];
        const distance = input.current.x - input.initial.x;
        if (distance >= 5 || distance <= -5) {
            const left = distance < 0;
            const right = distance > 0;
            if (left) {
                this.rotate(this.currentIndex - (this.controlReverse ? -1 : 1));
            } else if (right) {
                this.rotate(this.currentIndex + (this.controlReverse ? -1 : 1));
            }
        }
        this.el.classList.remove('grabbing');
    }

    pause() {
        this.paused = true;
        this.el.classList.add('disable-controls');
    }

    resume() {
        this.paused = false;
        this.el.classList.remove('disable-controls');
    }

    showArrows() {
        if (this.arrowsEnable) {
            this.next.classList.remove('hide');
            this.prev.classList.remove('hide');
        }
    }

    hideArrows() {
        this.next.classList.add('hide');
        this.prev.classList.add('hide');
    }

    exterior() {
        this.stepNumber = 2;
        this.stepName = 'exterior';
        this.frames = this.el.querySelectorAll('.frame');
        this.angles = this.config.angles;
        this.currentIndex = 0;

        if (this.config.angles > 1) {
            this.resume();
            this.showArrows();
        } else {
            this.pause();
            this.hideArrows();
        }

        this.rotate();
    }

    showFirstFrame() {
        this.el.querySelector('.frame')?.classList.remove('hide');
    }

    interior() {
        this.stepNumber = 3;
        this.stepName = 'interior';
        this.pause();
        this.hideArrows();
    }

    onDragEnd() {
        const model = this.parent.params.get('model');
        window.dataLayer.push({
            event: '360 Configurator',
            eventCategory: 'Car Configurator',
            eventAction: 'spin',
            eventLabel: `cars|${model}|configurator|Step ${this.stepNumber}. ${this.stepName}|spin|internal|top|#`,
            actionType: 'spin',
            businessUnit: 'cars',
            moduleName: 'configurator',
            clickText: 'spin',
            clickType: 'internal',
            destinationURL: '#',
            configuratorStepName: `Step ${this.stepNumber}. ${this.stepName}`,
            modelSelected: `${model}`,
            inPageLocation: 'middle',
        });
    }

    rotate(index) {
        let newIndex = (index ?? this.currentIndex) || 0;
        if (newIndex > this.angles - 1) {
            newIndex = index % this.angles;
        } else if (newIndex < 0) {
            newIndex = this.angles - (Math.abs(index % this.angles) || this.angles);
        }

        const viewUpdated = index === undefined;
        const rotated = this.currentIndex !== newIndex;

        if (viewUpdated || rotated) {
            this.currentIndex = newIndex;
            this.frames.forEach((frame, index) => {
                if (index === this.currentIndex) {
                    frame.classList.remove('hide');
                    this.currentFrame = +frame.dataset.frame;
                    this.currentFrameEl = frame;
                } else {
                    frame.classList.add('hide');
                }
            });
        }
    }
}
